import {httpLikeRequestTroughWebsocket} from '@stores/serverConnection/makeApiServerRequest';
import {PM_ACTIONS, PaymentGatewayResponse} from '@stores/serverConnection/types';
import {WsServerConnection} from "@stores/serverConnection/wsServerConnection";

export const requestGateway = async (wsServerConnection: WsServerConnection): Promise<'paddle' | 'invoice'> => {
    const resp = await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        'p/gateway',
        PM_ACTIONS.PAYMENT_GATEWAY,
        {},
        () => 'gateway',
    ) as PaymentGatewayResponse;

    return resp.gateway;
};
